import { combineReducers } from 'redux'
import admin from './reducers/admin'
import auth from './reducers/auth'
import ui from './reducers/ui'
import banner from './reducers/banner'
import reports from './reducers/report'

// combine reducers does not persist the key/namespaces
const rootReducer = combineReducers({
  admin,
  auth,
  ui,
  banner,
  reports,
})
export type AppState = ReturnType<typeof rootReducer>
export default rootReducer
